module.exports = __webpack_public_path__ + "img/IntroduceTitle.f9142505.png";